(function () {
    'use strict';
    var Charter = require('../../modules/Charter');
    var randomColor = require('randomcolor');

    var colors = randomColor({
        count: 20,
        format: 'rgbArray',
    });

    var $averagesChart = $('#company-averages-chart');

    if ($averagesChart.length > 0) {
        var companyAverages = greenmotion.companyAverages;
        var ids = [
            { id: '#company-averages-chart', key: 'overall' },
            { id: '#company-q1-chart', key: 'q1' },
            { id: '#company-q2-chart', key: 'q2' },
            { id: '#company-q3-chart', key: 'q3' },
            { id: '#company-q4-chart', key: 'q4' },
            { id: '#company-q5-chart', key: 'q5' },
        ];

        $.each(ids, function (index, element) {
            var dataset = companyAverages[element.key];

            dataset.map(function (item, index) {
                item.strokeColor =
                    'rgba(' + colors[index][0] + ',' + colors[index][1] + ',' + colors[index][2] + ', 1)';
                item.pointColor = 'rgba(' + colors[index][0] + ',' + colors[index][1] + ',' + colors[index][2] + ', 1)';
                item.fillColor = 'rgba(' + colors[index][0] + ',' + colors[index][1] + ',' + colors[index][2] + ', 0)';
                return item;
            });

            Charter.line($(element.id), companyAverages.labels, dataset, {
                // String - Template string for multiple tooltips
                multiTooltipTemplate: '<%= value %>: <%= datasetLabel %>',
                datasetStroke: true,
                datasetStrokeWidth: 4,
            });
        });

        $('#feedback-company-filter')
            .find('select#months-filter')
            .on('change', function (e) {
                $(this).closest('form').submit();
            });
    }
})();
